// extracted by mini-css-extract-plugin
module.exports = {"card_camp_list":"card_camp_list___14M5g"};